import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import tourSteps from "./tourSteps";
import { Api } from "config/api";
import { SDCloudBackendAPIWithToken } from "apis/backendAPI";

export const getTourBlockers = (path, val) => {
  localStorage.setItem(`tourBlocker:${path}`, val.toString());
};

const TourManager = () => {
  const location = useLocation();
  const currentDriver = useRef(null);
  const previousPath = useRef(null);

  useEffect(() => {
    const path = location.pathname;
    const steps = tourSteps[path];

    const profileData = JSON.parse(localStorage.getItem("profileData") || "{}");
    const isTourDone = profileData?.tour_progress?.[path] === true;
    const is_new_user = profileData?.is_new_user === true;
    const privilege = profileData?.privilege === "admin";
    const isTourBlocked = localStorage.getItem(`tourBlocker:${path}`) === "true";

    // Destroy old tour if switching pages
    if (currentDriver.current) {
      currentDriver.current.destroy();
      currentDriver.current = null;
    }

    
    if (
      privilege || 
      !is_new_user || 
      !steps?.length ||
      isTourBlocked == true || 
      isTourBlocked == "true" ||
      isTourDone
    ) {
      return;
    }

    const driverObj = driver({
      showProgress: true,
      allowClose: false,
      steps,
      onPopoverRender: (popover) => {
        const dismissButton = document.createElement("button");
        dismissButton.innerText = "Dismiss";
        popover.footerButtons.appendChild(dismissButton);
    
        dismissButton.addEventListener("click", () => {
          driverObj.destroy();
        });
      },
      onDestroyed: () => {
        const profileData = JSON.parse(localStorage.getItem("profileData") || "{}");

        if (!profileData.tour_progress) {
          profileData.tour_progress = {};
        }

        profileData.tour_progress[path] = true;

        const allToursDone = Object.keys(tourSteps).every(
          (tourPath) => profileData.tour_progress?.[tourPath] === true
        );

        // Mark user as no longer new if all done
        if (allToursDone) {
          profileData.is_new_user = false;
        }

        // Update localStorage
        localStorage.setItem("profileData", JSON.stringify(profileData));
        
        // Sync with backend
        SDCloudBackendAPIWithToken()
        .put(Api.updateUserProfile, {
          username: localStorage.getItem("userName"),
          tour_progress: {
            [path]: true
          },
          ...(allToursDone && { is_new_user: false }), // ← conditionally update the payload
        }, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .catch(() => {});
      },
    });

    previousPath.current = path;
    currentDriver.current = driverObj;
    
    window.requestAnimationFrame(() => {
      setTimeout(() => {
        driverObj.drive();
      }, 2000); // adjustable delay
    });
  }, [location.pathname]);

  return null;
};

export const launchQuickTour = (path, options = {}) => {
  const steps = tourSteps[path];
  if (!steps?.length) return;

  const driverObj = driver({
    showProgress: true,
    allowClose: options.allowClose ?? false,
    steps,
    onPopoverRender: (popover) => {
      const dismissButton = document.createElement("button");
      dismissButton.innerText = "Dismiss";
      popover.footerButtons.appendChild(dismissButton);
  
      dismissButton.addEventListener("click", () => {
        driverObj.destroy();
      });
    },
  });

  driverObj.drive();

  const handleRouteChange = () => {
    driverObj.destroy();
    removeListeners();
  };

  // Cleanup
  const removeListeners = () => {
    window.removeEventListener("popstate", handleRouteChange);
    window.removeEventListener("pushState", handleRouteChange);
    window.removeEventListener("replaceState", handleRouteChange);
  };

  // Add listeners if user goes to some other page
  window.addEventListener("popstate", handleRouteChange);
  window.addEventListener("pushState", handleRouteChange);
  window.addEventListener("replaceState", handleRouteChange);
};

export default TourManager;
